module.exports = __webpack_public_path__ + "static/media/1.56275d80.webp";